import React from 'react';
import { NavLink } from 'react-router-dom';
import { withTranslation } from 'react-i18next';

class About3 extends React.Component {
    render() {
        const { t } = this.props;
        return (
            <div className="about-feature mobile-page-padding">
                <div className="container">
                    <div className="about-feature-grid">
                        {/* Contenido */}
                        <div className="about-feature-content">
                            <p className="about-feature-eyebrow">{t('pages.about.about3.eyebrow')}</p>
                            <h2 className="about-feature-title">{t('pages.about.about3.title')}</h2>
                            <div className="about-feature-rule" />
                            <p className="about-feature-text">{t('pages.about.about3.paragraph')}</p>
                            <NavLink to="/presentacion" className="about-feature-link">
                                {t('pages.about.about3.button')}
                                <span className="arw">&rarr;</span>
                            </NavLink>
                        </div>

                        {/* Media — imagen con marco de acento desfasado.
                            Para cambiarla: reemplaza src/images/admin-.png (o pide
                            cambiar el require por otro archivo). */}
                        <div className="about-feature-media">
                            <img src={require('../../images/about-slider/about_2.png')} alt={t('pages.about.about3.title')} />
                        </div>
                    </div>
                </div>
            </div>
        );
    }
};

export default withTranslation()(About3);
